import {TimelineMax, Power3, Quad, Sine} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');

    const view = new PIXI.Graphics();
    const cwin = new PIXI.Graphics();
    view.cwin = cwin;

    const crlo2 = Shortcuts.addTo(Shortcuts.getSprite('ravenKrilo2', TextureCache), 'crlo2', cwin);
    crlo2.anchor.set(187.75 / 262, 396.65 / 431);
    crlo2.position.set(113.9, 180.75);

    const crlo1 = Shortcuts.addTo(Shortcuts.getSprite('ravenKrilo1', TextureCache), 'crlo1', cwin);
    crlo1.anchor.set(638.4 / 703, 627.75 / 720);
    crlo1.position.set(248.85, 102.1);

    const bodyin = Shortcuts.addTo(Shortcuts.getSprite('ravenTelo', TextureCache), 'bodyin', cwin);
    bodyin.anchor.set(318.3 / 637, 183.7 / 368);
    bodyin.position.set(202.05, 213.5);

    const leg2 = Shortcuts.addTo(Shortcuts.getSprite('ravenNoga2', TextureCache), 'leg2', cwin);
    leg2.anchor.set(21.4 / 133, 18.6 / 128);
    leg2.position.set(137.55, 355.9);

    const leg1 = Shortcuts.addTo(Shortcuts.getSprite('ravenNoga1', TextureCache), 'leg1', cwin);
    leg1.anchor.set(15.15 / 105, 18.4 / 147);
    leg1.position.set(86.3, 389.85);

    const hvost = Shortcuts.addTo(Shortcuts.getSprite('ravenHvost', TextureCache), 'hvost', cwin);
    hvost.anchor.set(294.8 / 312, 72.7 / 191);
    hvost.position.set(-53.9, 279.45);

    const clw = Shortcuts.addTo(Shortcuts.getSprite('ravenKluv', TextureCache), 'clw', cwin);
    clw.anchor.set(15.7 / 159, 26.25 / 52);
    clw.position.set(353.25, 128.85);

    const yazik = Shortcuts.addTo(Shortcuts.getSprite('ravenYazik', TextureCache), 'yazik', cwin);
    yazik.anchor.set(5.5 / 56, 6.15 / 13);
    yazik.position.set(399.7, 103.5);


    view.position.set(sizes.width / 2, 619);
    cwin.position.set(-1292, 102.2);

    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, 0x000000);
    overlay.alpha = 0;

    view.z = -0.3;
    crlo2.z = -0.5;
    leg2.z = -0.5;

    view.addChild(cwin);
    cont.addChild(view);
    cont.addChild(overlay);

    instance.cont = cont;
    instance.view = view;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.overlay = overlay;

    instance.parallaxLayers = [view, crlo2, leg2];
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}


const _constructTimeline = instance => {
    const __getRad = Shortcuts.getRad;

    const tl = new TimelineMax({paused: true});
    const d1 = 2.4, d2 = 0.05, d3 = 0.7;

    tl.set(instance.overlay, {alpha: 0}, 'in');

    tl.to(instance.overlay, d1, {alpha: 1}, 'in');
    tl.to(instance.overlay, d2, {alpha: 1}, 'idle');
    tl.to(instance.overlay, d3, {alpha: 0}, 'out');

    const view = instance.view;



    tl.set(view, {y:619, z: -0.3}, 'in');
    tl
        .to(view,  1, {z:2.5, ease: Quad.easeInOut}, 'in')
        .to(view,  0.4, {y:566, ease: Quad.easeIn}, 'in')
        .to(view,  0.6, {y:487, ease: Quad.easeOut}, 'in+=' + 0.4);



    tl.set(view.cwin.scale, {x:0.4, y:0.4}, 'in');
    tl.set(view.cwin, {rotation: __getRad(8), x:-1293, y:0}, 'in');
    tl
        .to(view.cwin.scale,  3.7, {x:3.88, y:3.88, ease: Sine.easeOut}, 'in')
        .to(view.cwin,  3.7, {rotation: __getRad(10), x:3417, y:-641, ease: Sine.easeOut}, 'in');

// ____Leg1

    tl.set(view.cwin.leg1, {rotation: __getRad(-10)}, 'in');
    tl
        .to(view.cwin.leg1,  0.76, {rotation: __getRad(-40.7)}, 'in+=' +  0.2);

// ____Leg2
    tl.set(view.cwin.leg2, {rotation: __getRad(-10)}, 'in');
    tl
        .to(view.cwin.leg2,  0.76, {rotation: __getRad(-40.5)}, 'in+=' + 0.4);

// ____Hvost
    tl.set(view.cwin.hvost, {rotation: 0}, 'in');
    tl
        .to(view.cwin.hvost,  0.76, {rotation: __getRad(-3.7)}, 'in+=' + 0.08);

//	bodyin
    tl.set(view.cwin.bodyin, {x: 202}, 'in');
    tl
        .to(view.cwin.bodyin,  0.76, {x: 192}, 'in+=' + 0.08);

//	crlo1
    tl.set(view.cwin.crlo1, {rotation: __getRad(11), x:110, y:180}, 'in');
    tl
        .to(view.cwin.crlo1,  0.24, {rotation: __getRad(-5), x:112, y:189, ease: Power3.easeIn}, 'in+=' + 0.16)
        .to(view.cwin.crlo1,  0.96, {rotation: __getRad(-26), x:118, y:180, ease: Power3.easeOut}, 'in+=' + 0.4);

//	crlo2
    tl.set(view.cwin.crlo2, {rotation: __getRad(-19), x:248, y:102}, 'in');
    tl
        .to(view.cwin.crlo2,  0.24, {rotation: __getRad(-6), x:247, y:101, ease: Power3.easeIn}, 'in+=' + 0.16)
        .to(view.cwin.crlo2,  0.96, {rotation: __getRad(10.8), x:250, y:101, ease: Power3.easeOut}, 'in+=' + 0.4);

//	clw
    tl.set(view.cwin.clw, {rotation: __getRad(-15)}, 'in');
    tl
        .to(view.cwin.clw,  0.16, {rotation: __getRad(6.7), ease: Power3.easeIn}, 'in+=' + 0.24)
        .to(view.cwin.clw,  0.6, {rotation: __getRad(13.7), ease: Power3.easeOut}, 'in+=' + 0.4);

//	clw
    tl.set(view.cwin.yazik, {rotation: 0}, 'in');
    tl
        .to(view.cwin.yazik,  0.6, {rotation: __getRad(-8.9), ease: Power3.easeOut}, 'in+=' + 0.24);


    instance.timeline = tl;
    return tl;
}


function RavenTransition(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 2.4;
    constructor.totalDuration = 3.9;

    return constructor;
}


module.exports = RavenTransition;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/transitions/RavenTransition.js